import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { useAuth, formatApiError } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created");
      navigate("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative iw-noise">
      <div className="w-full max-w-md iw-card p-8 fade-up relative z-10">
        <Link to="/"><Logo /></Link>
        <p className="overline mt-8">Get Started Free</p>
        <h1 className="font-display text-3xl font-bold mt-1 mb-6">Create your account</h1>
        <form onSubmit={submit} className="space-y-4">
          <input className="iw-input" placeholder="Full name" value={form.name} onChange={set("name")} required data-testid="register-name" />
          <input className="iw-input" type="email" placeholder="Email address" value={form.email} onChange={set("email")} required data-testid="register-email" />
          <input className="iw-input" type="password" placeholder="Password" value={form.password} onChange={set("password")} required data-testid="register-password" />
          <button disabled={loading} className="btn-gold w-full py-3 rounded-full" data-testid="register-submit">{loading ? "Creating…" : "Create Account"}</button>
        </form>
        <p className="text-sm text-[#8B9BB4] mt-6">Already have an account? <Link to="/login" className="text-[#D4AF37] font-semibold">Sign in</Link></p>
      </div>
    </div>
  );
}
